module.exports = __webpack_public_path__ + "static/img/banner_jing.013783a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_jing.png
// module id = rYEN
// module chunks = 1